'use client';

import { useSearchParams } from 'next/navigation';
import { getCookie } from 'cookies-next';
import { useEffect, useState } from 'react';
import { useClientCapabilities } from './use-client-capabilities';

/**
 * Checks if current request is a webview request.
 * Returns undefined while the webview state enumeration is not ready.
 */
export const useIsWebviewRequest = (): boolean | undefined => {
  let [isWebviewRequest, setIsWebviewRequest] = useState<boolean>();
  let params = useSearchParams();
  let clientIdentifier = useClientCapabilities();

  let byClient = clientIdentifier.isWebViewCapable();

  let queryValue = params?.get('webview');
  let hasWebviewInQuery = queryValue === '1' || queryValue === 'true';

  // TODO: Centralize `webview` cookie name -- See `COOKIE_NAME_WEBVIEW`.
  let cookieValue = getCookie('webview');
  let hasWebviewInCookie =
    cookieValue === '1' || cookieValue === 'true' || cookieValue === true;

  let win = typeof window !== 'undefined' ? window : null;

  useEffect(() => {
    if (typeof isWebviewRequest !== 'undefined' || win === null) {
      return;
    }

    setIsWebviewRequest(byClient || hasWebviewInQuery || hasWebviewInCookie);
  }, [win, byClient, hasWebviewInQuery, isWebviewRequest, hasWebviewInCookie]);

  if (clientIdentifier.isWebViewCapable()) {
    return true;
  }

  return isWebviewRequest;
};
